import { render, staticRenderFns } from "./idxDownload.vue?vue&type=template&id=31e9b0e1&"
import script from "./idxDownload.vue?vue&type=script&lang=js&"
export * from "./idxDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports